import { PAGE_TITLE_SUFFIX } from '../app.constants';
import { StepDetail } from './depot-requete.model';

export const depotRequeteBasePath = 'depot-requete';
export const PAGE_TITLE_PREFIX = ' | Dépôt d\'une requête'

export const depotRequeteSteps: StepDetail[] = [
    new StepDetail({
        route: 'avertissement',
        breadTitle: 'Avertissement',
        pageTitle: `Avertissement (Étape 1)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    }),
    new StepDetail({
        route: 'requerants',
        breadTitle: 'Requérant',
        pageTitle: `Requérant (Étape 2)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    }),
    new StepDetail({
        route: 'juridiction',
        breadTitle: 'Juridiction',
        pageTitle: `Choix de la juridiction (Étape 3)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    }),
    new StepDetail({
        route: 'requete',
        breadTitle: 'Requête',
        pageTitle: `Requête (Étape 4)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    }),
    new StepDetail({
        route: 'justificatifs',
        breadTitle: 'Justificatifs',
        pageTitle: `Ajout des justificatifs (Étape 5)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    }),
    new StepDetail({
        route: 'recapitulatif',
        breadTitle: 'Récapitulatif',
        pageTitle: `Récapitulatif (Étape 6)${PAGE_TITLE_PREFIX}${PAGE_TITLE_SUFFIX}`
    })
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete.data.ts